//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    link: String,
    linkText: String,
    leftAlign: {
      type: Boolean,
      default: false
    }
  }
}
